import ozUserRecommendations from './oz-user-recommendations.vue'

export default ozUserRecommendations
